// extracted by mini-css-extract-plugin
export var commPress = "CommuniquesDePresseParAnneeSection-module--commPress--5e8b2";
export var container = "CommuniquesDePresseParAnneeSection-module--container--bed5f";